"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Application extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'application';
        this._clientName = initParams.client_name;
        this._allowedGrants = (0, util_1.camelArray)(initParams.allowed_grants);
        this._scopes = (0, util_1.camelArray)(initParams.scopes);
    }
    set clientName(value) {
        console.error('Do not set objects this way');
    }
    get clientName() {
        return this._clientName;
    }
    set allowedGrants(value) {
        console.error('Do not set objects this way');
    }
    get allowedGrants() {
        return this._allowedGrants;
    }
    set scopes(value) {
        console.error('Do not set objects this way');
    }
    get scopes() {
        return this._scopes;
    }
    delete() {
        return this.dataService.deleteApplication(this.id, this);
    }
}
exports.default = Application;
//# sourceMappingURL=application.js.map